import { UnifiedClassAssessments } from "../models/UnifiedClassAssessments";
import { UnifiedClassAssessmentsDTO } from "../dto/UnifiedClassAssessmentsDTO";

export const unifiedClassAssessmentsMapper = (
  unifiedClassAssessment: UnifiedClassAssessmentsDTO,
): UnifiedClassAssessments => {
  return new UnifiedClassAssessments({
    assessmentId: unifiedClassAssessment.assessmentId,
    skillId: unifiedClassAssessment.skillId,
    assessmentName: unifiedClassAssessment.assessmentName,
    assessmentSeq: unifiedClassAssessment.assessmentSeq,
  });
};
